export function getPath(state) {
	var fullPath = "/contests";

	if (state.activeView) {
		fullPath += "/" + state.activeView;
	}

	var queryParts = []

	if (state.showInviteModal) {
		queryParts.push("show_invite_modal=" + state.showInviteModal);
	}
	if (state.showSchoolInfoModal) {
		queryParts.push("show_school_info_modal=" + state.showSchoolInfoModal);
	}
	if (state.csSchoolID) {
		queryParts.push("cs_school_id=" + state.csSchoolID);
	}
	if (state.l2eSchoolID) {
		queryParts.push("l2e_school_id=" + state.l2eSchoolID);
	}

	if (queryParts.length) {
		fullPath += "?" + queryParts.join("&");
	}

	return fullPath;
}

export function getRouteState(params) {
	var state = {};

	if (params.active_view) {
		state.activeView = params.active_view;
	} else {
		state.activeView = VIEWS.WRITING;
	}

	if (params.show_invite_modal) {
		state.showInviteModal = true;
	} else {
		state.showInviteModal = false;
	}

	if (params.show_school_info_modal) {
		state.showSchoolInfoModal = true;
	} else {
		state.showSchoolInfoModal = false;
	}

	if (params.cs_school_id) {
		state.csSchoolID = params.cs_school_id;
	}
	if (params.l2e_school_id) {
		state.l2eSchoolID = params.l2e_school_id;
	}
	
	return state;
}

export var PATH = "/contests/:active_view?";

export var VIEWS = {
	READING: "reading",
	WRITING: "writing",
	OWLSTAGRAM: "owlstagram",
}


// WEBPACK FOOTER //
// ./modules/lib/routing/ContestsRouting.js